import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=c82a6c42&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=c82a6c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82a6c42",
  null
  
)

export default component.exports